import React from 'react';
import { Icon } from './Icon.js';
export const IconCrown2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2.5 15H21.5", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M20.9999 20H2.99994L2.06342 7H3.13038L6.99994 9.78125L11.3574 3H12.6425L16.9999 9.78125L20.8695 7H21.9365L20.9999 20Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconCrown2.js.map